exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".input-tags[data-v-3f2190e2]{padding:10px;border:1px solid #b7c0c9;width:auto;min-height:100px;height:100px;overflow-y:auto}.el-tag[data-v-3f2190e2]{margin-right:5px;margin-bottom:5px}.button-new-tag[data-v-3f2190e2]{height:24px;line-height:24px;padding-top:0;padding-bottom:0}.input-new-tag[data-v-3f2190e2]{width:90px;margin-left:10px;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-3f2190e2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/inputTags.vue
// module id = 982
// module chunks = 1